import VirtualTable from "../../../components/custom/VirtualTable";
import { MessageGroupData } from "../../../globals/interfaces";

export default function GroupsTable({
    groups,
    setSelectedGroup,
    handleCreateUpate,
    tableIndex
}: {
    groups: Array<MessageGroupData>;
    setSelectedGroup: (messageGroupData?: MessageGroupData) => void;
    handleCreateUpate?: (messageGroupData?: MessageGroupData) => void;
    tableIndex?: number;
}) {

    const mapping = handleCreateUpate ?
        [{
            name: 'Name',
            value: 'name'
        }, {
            name: '',
            value: 'fas fa-edit',
            icon: true,
            function: (item: MessageGroupData) => handleCreateUpate(item)
        }] :
        [{
            name: 'Name',
            value: 'name'
        }];


    return (
        <VirtualTable
            data={groups}
            // @ts-ignore
            mapping={mapping}
            handleClick={setSelectedGroup}
            externalSelectedRowIndex={tableIndex}
            numRows={10}
        />
    );
}